import { createAsyncAction } from 'typesafe-actions';

import { HAOpsDashboardData } from './types';

export const getHAOpsDashboard = createAsyncAction(
  'haOps/getHAOpsDashboard/request',
  'haOps/getHAOpsDashboard/success',
  'haOps/getHAOpsDashboard/failure',
)<undefined, HAOpsDashboardData, undefined>();
